// Return the vertical center of the part of a Frame that is currently visible. The value is
// relative to the Frame, so an absolutely positioned overlay can follow it while remaining
// constrained to that component.
export function visibleFrameCenter(rect, viewportHeight) {
  const visibleTop = Math.max(rect.top, 0)
  const visibleBottom = Math.min(rect.bottom, viewportHeight)

  if (visibleBottom <= visibleTop) return rect.height / 2

  return ((visibleTop + visibleBottom) / 2) - rect.top
}
